(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df54-purchase-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('df54-purchase-help')) {
    customElements.define('df54-purchase-help', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.product-section');
        if (!this.root) return;
        this.defaults = new Map([
          ['Extended Warranty', '1-Year Warranty Included']
        ]);
        this.choices = new Map();
        this.initialized = new WeakSet();
        this.initializedScales = new WeakSet();
        this.scaleChoices = null;
        this.applying = false;
        this.queued = false;
        this.onChange = event => {
          const select = event.target;
          if (!this.applying && select instanceof HTMLSelectElement && this.defaults.has(select.name) && select.value) this.choices.set(select.name, select.value);
          if (!this.applying && select instanceof HTMLInputElement && select.type === 'checkbox' && select.name === 'Include Scale') {
            const group = Array.from(this.root.querySelectorAll('input[type="checkbox"][name="Include Scale"]'));
            if (select.checked) {
              this.applying = true;
              for (const peer of group) {
                if (peer === select || !peer.checked) continue;
                if (select.value === 'No Thank You' || peer.value === 'No Thank You') {
                  peer.checked = false;
                  peer.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
              this.applying = false;
            }
            this.scaleChoices = group.filter(input => input.checked).map(input => input.value);
          }
        };
        this.root.addEventListener('change', this.onChange, true);
        this.observer = new MutationObserver(() => {
          if (this.queued) return;
          this.queued = true;
          queueMicrotask(() => { this.queued = false; if (this.isConnected) this.initializeOptions(); });
        });
        this.observer.observe(this.root, { childList: true, subtree: true });
        this.initializeOptions();
      }
      initializeOptions() {
        for (const select of this.root.querySelectorAll('select[data-type="select"]')) {
          if (!this.defaults.has(select.name) || this.initialized.has(select)) continue;
          const value = this.choices.get(select.name) || select.value || this.defaults.get(select.name);
          if (!Array.from(select.options).some(option => option.value === value && !option.disabled)) continue;
          this.initialized.add(select);
          const helper = this.querySelector(select.name === 'Extended Warranty' ? '[data-df54-warranty-help]' : '[data-df54-burr-help]');
          const describedBy = new Set((select.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
          describedBy.add(helper.id);
          select.setAttribute('aria-describedby', Array.from(describedBy).join(' '));
          this.choices.set(select.name, value);
          if (select.value !== value) {
            this.applying = true;
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            this.applying = false;
          }
        }
        const scales = Array.from(this.root.querySelectorAll('input[type="checkbox"][name="Include Scale"]'));
        if (!scales.some(input => input.value === 'No Thank You') || scales.every(input => this.initializedScales.has(input))) return;
        const selected = scales.filter(input => input.checked).map(input => input.value);
        const preferred = this.scaleChoices === null ? (selected.length ? selected : ['No Thank You']) : this.scaleChoices;
        this.applying = true;
        for (const input of scales) {
          this.initializedScales.add(input);
          const checked = preferred.includes(input.value);
          if (input.checked !== checked) {
            input.checked = checked;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.applying = false;
        this.scaleChoices = preferred;
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.root) this.root.removeEventListener('change', this.onChange, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["df54-purchase-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('df54-purchase-status')) {
    customElements.define('df54-purchase-status', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.product-section');
        if (!this.root) return;
        this.variants = JSON.parse(this.querySelector('[data-df54-variants]').textContent);
        this.onVariantChange = event => this.renderVariant(event.detail.variant);
        this.root.addEventListener('variantChange', this.onVariantChange);
        const id = this.dataset.initialId;
        this.renderVariant(this.variants.find(variant => String(variant.id) === String(id)));
      }
      renderVariant(variant) {
        const preorder = Boolean(variant && variant.available && /preorder/i.test(variant.title));
        this.querySelector('[data-df54-state]').textContent = !variant ? this.dataset.choose : !variant.available ? this.dataset.soldOut : preorder ? this.dataset.preorder : this.dataset.inStock;
        this.querySelector('[data-df54-pickup]').hidden = !preorder;
        const match = variant && String(variant.option1 || '').match(/\(([^)]+)\)/);
        this.querySelector('[data-df54-estimate]').textContent = match ? match[1] : this.dataset.fallback;
      }
      disconnectedCallback() {
        if (this.root) this.root.removeEventListener('variantChange', this.onVariantChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["df64-purchase-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('df64-purchase-help')) {
    customElements.define('df64-purchase-help', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.product-section');
        if (!this.root) return;
        this.defaults = new Map([
          ['Burr Upgrade (Stock Burr Option Included)', 'No Burr Upgrade'],
          ['Extended Warranty', '1-Year Included with Purchase']
        ]);
        this.choices = new Map();
        this.initialized = new WeakSet();
        this.initializedScales = new WeakSet();
        this.scaleChoices = null;
        this.applying = false;
        this.queued = false;
        this.onChange = event => {
          const select = event.target;
          if (!this.applying && select instanceof HTMLSelectElement && this.defaults.has(select.name) && select.value) this.choices.set(select.name, select.value);
          if (!this.applying && select instanceof HTMLInputElement && select.type === 'checkbox' && select.name === 'Include Scale') {
            const group = Array.from(this.root.querySelectorAll('input[type="checkbox"][name="Include Scale"]'));
            if (select.checked) {
              this.applying = true;
              for (const peer of group) {
                if (peer === select || !peer.checked) continue;
                if (select.value === 'No Thank You' || peer.value === 'No Thank You') {
                  peer.checked = false;
                  peer.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
              this.applying = false;
            }
            this.scaleChoices = group.filter(input => input.checked).map(input => input.value);
          }
        };
        this.root.addEventListener('change', this.onChange, true);
        this.observer = new MutationObserver(() => {
          if (this.queued) return;
          this.queued = true;
          queueMicrotask(() => { this.queued = false; if (this.isConnected) this.initializeOptions(); });
        });
        this.observer.observe(this.root, { childList: true, subtree: true });
        this.initializeOptions();
      }
      initializeOptions() {
        for (const select of this.root.querySelectorAll('select[data-type="select"]')) {
          if (!this.defaults.has(select.name) || this.initialized.has(select)) continue;
          const value = this.choices.get(select.name) || select.value || this.defaults.get(select.name);
          if (!Array.from(select.options).some(option => option.value === value && !option.disabled)) continue;
          this.initialized.add(select);
          const helper = this.querySelector(select.name === 'Extended Warranty' ? '[data-df64-warranty-help]' : '[data-df64-burr-help]');
          const describedBy = new Set((select.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
          describedBy.add(helper.id);
          select.setAttribute('aria-describedby', Array.from(describedBy).join(' '));
          this.choices.set(select.name, value);
          if (select.value !== value) {
            this.applying = true;
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            this.applying = false;
          }
        }
        const scales = Array.from(this.root.querySelectorAll('input[type="checkbox"][name="Include Scale"]'));
        if (!scales.some(input => input.value === 'No Thank You') || scales.every(input => this.initializedScales.has(input))) return;
        const selected = scales.filter(input => input.checked).map(input => input.value);
        const preferred = this.scaleChoices === null ? (selected.length ? selected : ['No Thank You']) : this.scaleChoices;
        this.applying = true;
        for (const input of scales) {
          this.initializedScales.add(input);
          const checked = preferred.includes(input.value);
          if (input.checked !== checked) {
            input.checked = checked;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.applying = false;
        this.scaleChoices = preferred;
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.root) this.root.removeEventListener('change', this.onChange, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["df64-purchase-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('df64-purchase-status')) {
    customElements.define('df64-purchase-status', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.product-section');
        if (!this.root) return;
        this.variants = JSON.parse(this.querySelector('[data-df64-variants]').textContent);
        this.onVariantChange = event => this.renderVariant(event.detail.variant);
        this.root.addEventListener('variantChange', this.onVariantChange);
        const id = this.dataset.initialId;
        this.renderVariant(this.variants.find(variant => String(variant.id) === String(id)));
      }
      renderVariant(variant) {
        const preorder = Boolean(variant && variant.available && /preorder/i.test(variant.title));
        this.querySelector('[data-df64-state]').textContent = !variant ? this.dataset.choose : !variant.available ? this.dataset.soldOut : preorder ? this.dataset.preorder : this.dataset.inStock;
        this.querySelector('[data-df64-pickup]').hidden = !preorder;
        const match = variant && String(variant.option1 || '').match(/\(([^)]+)\)/);
        this.querySelector('[data-df64-estimate]').textContent = match ? match[1] : this.dataset.fallback;
      }
      disconnectedCallback() {
        if (this.root) this.root.removeEventListener('variantChange', this.onVariantChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
